/* ==========================================================================
   Pride Bodyboards — le peu de JS que le rapprochement demande.

   SOURCE DE VERITE. Ce fichier est INLINE dans le reglage `custom_html_head`
   par `engine/src/pride-head.mjs`, exactement comme pride-design.css. Ne pas
   editer le reglage a la main : le prochain passage du script l ecraserait.

   ⚠️ ON N EN MET QUE LE STRICT NECESSAIRE. Tout ce qui peut se faire en CSS se
   fait en CSS — les bandes d images defilent deja toutes seules par
   `scroll-snap`, sans une ligne de JS. Ce fichier n ajoute que ce que la CSS ne
   sait pas faire : l AFFORDANCE.
   ========================================================================== */

(function () {
  'use strict'

  /* --------------------------------------------------------------------------
     Les fleches des bandes d images.

     ⚠️ POURQUOI ELLES SONT NECESSAIRES. Retour de Loic le 2026-08-19 : « il
     manque le chargement du carousel ». Les bandes chargeaient bien — mesure :
     9 images, `scrollWidth` 5120 pour 1280 visibles, donc defilables. Ce qui
     manquait, c est le SIGNE qu on peut les faire defiler. La source affiche un
     chevron « › » blanc de 80 px, a 127 px du bord droit, centre verticalement ;
     le « ‹ » n apparait qu une fois la premiere vue passee.

     Une bande qui ne montre pas qu elle defile passe pour une image fixe. Le
     defilement, lui, marchait deja.

     ⚠️ DEUX BANDES DE TAILLES TRES DIFFERENTES, UNE SEULE MECANIQUE (2026-08-20) :
     les grandes vues 16/9 des pages d univers, et la bande de vignettes des
     tuiles de categorie, bornee a six vignettes. Envelopper, poser deux chevrons,
     les cacher aux extremites : c est le meme geste. Seuls les noms de classe
     changent, la CSS fait le reste.
     -------------------------------------------------------------------------- */
  function poserFleches(bande, classeCadre, classeFleche, decorative) {
    if (bande.dataset.prArmee) return
    bande.dataset.prArmee = '1'

    // Les fleches ne peuvent PAS vivre dans la bande : elle defile, elles
    // partiraient avec le contenu. On l enveloppe.
    var cadre = document.createElement('div')
    cadre.className = classeCadre
    bande.parentNode.insertBefore(cadre, bande)
    cadre.appendChild(bande)

    var boutons = ['prec', 'suiv'].map(function (sens) {
      var b = document.createElement('button')
      b.type = 'button'
      b.className = classeFleche + ' ' + classeFleche + '--' + sens
      b.setAttribute('aria-label', sens === 'prec' ? 'Image précédente' : 'Image suivante')
      // ⚠️ La bande de vignettes est `aria-hidden` : elle ne fait que redire les
      // images de la fiche. Un bouton focusable la-dedans serait a la fois une
      // faute d accessibilite et un piege au clavier — sur une page de categorie
      // ca ferait quarante arrets invisibles avant le produit suivant.
      if (decorative) b.tabIndex = -1
      b.innerHTML = sens === 'prec' ? '&lsaquo;' : '&rsaquo;'
      b.addEventListener('click', function () {
        bande.scrollBy({ left: (sens === 'prec' ? -1 : 1) * bande.clientWidth, behavior: 'smooth' })
      })
      cadre.appendChild(b)
      return b
    })

    function majFleches() {
      // 2 px de marge : les navigateurs arrondissent `scrollLeft`, et une
      // comparaison stricte laissait la fleche « suivant » visible sur la
      // derniere vue.
      var debut = bande.scrollLeft <= 2
      var fin = bande.scrollLeft >= bande.scrollWidth - bande.clientWidth - 2
      boutons[0].hidden = debut
      boutons[1].hidden = fin
    }

    bande.addEventListener('scroll', majFleches, { passive: true })
    window.addEventListener('resize', majFleches)
    majFleches()
  }

  function armerBandes() {
    document.querySelectorAll('.pr-carrousel').forEach(function (bande) {
      poserFleches(bande, 'pr-carrousel-cadre', 'pr-carrousel__fleche', false)
    })
    document.querySelectorAll('.pr-cat__bande-piste').forEach(function (bande) {
      poserFleches(bande, 'pr-cat__piste-cadre', 'pr-cat__fleche', true)
      armerApercu(bande)
    })
  }

  /* --------------------------------------------------------------------------
     L apercu : survoler une vignette de la bande montre son visuel en grand.

     Demande de Loic le 2026-08-20. Le remplacement ne dure QUE le survol : on
     quitte la vignette, l image de tete revient.

     ⚠️ AUCUNE IMAGE N EST AJOUTEE. Symmetry empile deja toutes les images du
     produit dans la tuile, une div par visuel, appariee par `data-media-id`.
     L apercu ne fait que designer laquelle se montre — la CSS fait le reste.

     ⚠️ `mouseenter`, PAS `mouseover` : la bande contient trente vignettes, et
     `mouseover` remonte. On serait rentre et sorti a chaque pixel parcouru.

     ⚠️ UNE VIGNETTE PEUT N AVOIR AUCUN VIS-A-VIS. La bande parcourt `product.media`
     — toutes les sortes de media — la pile ne porte que les IMAGES. Une video
     laisserait donc une vignette sans grand format : on ne fait rien, plutot que
     de vider la tuile.
     -------------------------------------------------------------------------- */
  function armerApercu(piste) {
    if (piste.dataset.prApercu) return
    piste.dataset.prApercu = '1'

    var bloc = piste.closest('.product-block')
    if (!bloc) return

    function eteindre() {
      bloc.classList.remove('pr-vue-en-cours')
      var vue = bloc.querySelector('.pr-vue-active')
      if (vue) vue.classList.remove('pr-vue-active')
    }

    // A l entree dans la bande, les images empilees deviennent affichables donc
    // chargeables. Rien ne se voit encore : elles sont a `opacity: 0`.
    piste.addEventListener('mouseenter', function () { bloc.classList.add('pr-vue-armee') })
    piste.addEventListener('mouseleave', function () {
      bloc.classList.remove('pr-vue-armee')
      eteindre()
    })

    piste.querySelectorAll('img[data-media-id]').forEach(function (vignette) {
      vignette.addEventListener('mouseenter', function () {
        var grand = bloc.querySelector('.product-block__image[data-media-id="' + vignette.dataset.mediaId + '"]')
        if (!grand) return
        eteindre()
        grand.classList.add('pr-vue-active')
        bloc.classList.add('pr-vue-en-cours')
      })
      vignette.addEventListener('mouseleave', eteindre)
    })
  }


  /* --------------------------------------------------------------------------
     ⚠️ LE FILTRE REMPLACE LA GRILLE, LES CHEVRONS PARTENT AVEC (2026-08-20).
     `FilterContainer.ajaxLoadUrl` (main.js) recharge la section et fait
     `ajaxContainers[index].innerHTML = ...` : apres chaque filtrage, chaque
     changement de tri et chaque « voir plus », les tuiles sont NEUVES et les
     bandes n ont plus de fleches. Un seul appel au chargement ne suffit donc pas.

     On re-arme sur mutation. C est idempotent — `data-pr-armee` ecarte les bandes
     deja equipees — et ca ne boucle pas : le cadre qu on insere declenche bien un
     second passage, mais celui-la ne trouve plus rien a faire.
     -------------------------------------------------------------------------- */
  function surveillerGrille() {
    var zones = document.querySelectorAll('[data-ajax-container]')
    if (!zones.length || !window.MutationObserver) return
    // ⚠️ Le filtrage AJAX remplace la barre utilitaire : le bouton FILTRER
    // deplace part avec elle, et le neuf revient a sa place d origine. On le
    // repose donc a chaque remplacement, en meme temps que les bandes.
    var obs = new MutationObserver(function () { armerBandes(); placerBoutonFiltre() })
    zones.forEach(function (zone) { obs.observe(zone, { childList: true, subtree: true }) })
  }

  /* --------------------------------------------------------------------------
     La fiche des riders, au TAP.

     ⚠️ SANS POINTEUR, IL N Y A PAS DE SURVOL. Un premier jet affichait donc la
     fiche EN PERMANENCE sous la photo sur mobile : lisible, mais ce n est pas le
     geste de la source, et ca allongeait chaque tuile de quatre lignes. Demande
     de Loic : la fiche s ouvre au clic sur l image.

     ⚠️ ON NE TOUCHE A RIEN AU POINTEUR. La regle `(hover: none)` decide : a la
     souris le survol fait deja le travail, et intercepter le clic empecherait
     d atteindre le lien.

     ⚠️ ET ON LAISSE PASSER LE CLIC SUR « PROFIL COMPLET ». Sans ce garde-fou, la
     fiche ouverte se refermait au lieu de suivre le lien — la tuile devenait un
     cul-de-sac.
     -------------------------------------------------------------------------- */
  var OUVERTE = 'pr-team__tuile--ouverte'

  function armerTuiles() {
    document.querySelectorAll('.pr-team__visuel').forEach(function (visuel) {
      if (visuel.dataset.prArmee) return
      visuel.dataset.prArmee = '1'
      visuel.addEventListener('click', function (ev) {
        if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return
        if (ev.target.closest('.pr-team__profil')) return
        var tuile = visuel.closest('.pr-team__tuile')
        var etait = tuile.classList.contains(OUVERTE)
        document.querySelectorAll('.' + OUVERTE).forEach(function (t) { t.classList.remove(OUVERTE) })
        if (!etait) tuile.classList.add(OUVERTE)
      })
    })
  }

  /* --------------------------------------------------------------------------
     Les deux filtres du blog Cinema.

     ⚠️ LE FILTRAGE SE FAIT DANS LE NAVIGATEUR, ET C EST POSSIBLE PARCE QUE LA
     GRILLE EST ENTIERE. La section rend les 34 videos d un coup, comme la
     source. Sur une liste paginee, filtrer ici ne filtrerait que la page
     affichee : « aucun resultat » alors que la video est page 2.

     ⚠️ CE NE SONT PAS DES SELECTS. La source n en utilise pas — un `<select>`
     natif fait dessiner sa liste par le SYSTEME, et ni le filet entre valeurs,
     ni leur centrage, ni le retrait serre ne sont alors atteignables. Le menu
     est donc a nous : un bouton et une `ul`, comme sur la source.

     ⚠️ LES DEUX FILTRES SE COMBINENT. Un rider ET une annee, pas l un ou
     l autre — sinon choisir une annee effacerait le rider deja choisi sans
     rien dire.
     -------------------------------------------------------------------------- */
  function armerCinema() {
    var grille = document.querySelector('[data-pr-cinema]')
    if (!grille || grille.dataset.prArmee) return
    grille.dataset.prArmee = '1'

    var cadre = grille.querySelector('.pr-cinema__grille')
    var tuiles = [].slice.call(grille.querySelectorAll('.pr-cinema__tuile'))
    var vide = grille.querySelector('[data-pr-vide]')
    var menus = [].slice.call(grille.querySelectorAll('[data-pr-menu]'))
    var valeurs = { rider: '', annee: '' }

    /* --------------------------------------------------------------------
       LE MOUVEMENT DES VIGNETTES.

       ⚠️ ON NE PEUT PAS ANIMER UN PASSAGE EN `display: none`. Cacher une tuile
       la retire du flux d un coup : les suivantes sautent a leur nouvelle place
       sans transition possible. C est la technique FLIP qu il faut — mesurer
       AVANT, appliquer le filtre, mesurer APRES, puis ramener chaque tuile a sa
       position de depart par un `transform` que l on relache aussitot.

       ⚠️ ET LES PARTANTES DOIVENT QUITTER LE FLUX TOUT DE SUITE, sinon les
       autres ne bougent pas tant que le fondu n est pas fini. On les fige donc
       en position absolue a l endroit exact qu elles occupaient — elles s y
       effacent pendant que les restantes glissent. C est ce que fait Isotope
       sur la source. Demande de Loic.
       -------------------------------------------------------------------- */
    var DUREE = 380
    var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    var generation = 0

    function nettoyer(t) {
      t.style.position = ''
      t.style.left = ''
      t.style.top = ''
      t.style.width = ''
      t.style.height = ''
      t.style.transform = ''
      t.style.transition = ''
      t.style.opacity = ''
      t.style.zIndex = ''
      t.style.pointerEvents = ''
    }

    function garder(t) {
      var tags = ' ' + (t.dataset.tags || '') + ' '
      // ⚠️ Comparer sur des etiquettes ENTOUREES D ESPACES : sans ca,
      //  « liam-lucas » serait trouve dans « liam-lucas-junior ».
      var okRider = !valeurs.rider || tags.indexOf(' ' + valeurs.rider + ' ') !== -1
      var okAnnee = !valeurs.annee || t.dataset.annee === valeurs.annee
      return okRider && okAnnee
    }

    function appliquer(anime) {
      var mien = ++generation

      if (!anime || !doux) {
        var vus = 0
        tuiles.forEach(function (t) {
          nettoyer(t)
          var ok = garder(t)
          t.hidden = !ok
          if (ok) vus++
        })
        if (vide) vide.hidden = vus !== 0
        return
      }

      var repere = cadre.getBoundingClientRect()
      var avant = new Map()
      tuiles.forEach(function (t) {
        // Une tuile deja figee par une animation precedente ne compte pas.
        if (!t.hidden && t.style.position !== 'absolute') avant.set(t, t.getBoundingClientRect())
      })

      var partent = []
      var arrivent = []
      var restent = []
      var vus = 0
      tuiles.forEach(function (t) {
        var ok = garder(t)
        if (ok) vus++
        var etait = avant.has(t)
        if (ok && etait) restent.push(t)
        else if (ok) arrivent.push(t)
        else if (etait) partent.push(t)
        else { nettoyer(t); t.hidden = true }
      })

      // 1. les partantes quittent le flux, figees la ou elles etaient
      partent.forEach(function (t) {
        var r = avant.get(t)
        t.style.position = 'absolute'
        t.style.left = (r.left - repere.left) + 'px'
        t.style.top = (r.top - repere.top) + 'px'
        t.style.width = r.width + 'px'
        t.style.height = r.height + 'px'
        t.style.zIndex = '0'
        t.style.pointerEvents = 'none'
        t.style.transition = 'none'
      })

      // 2. les arrivantes reprennent leur place dans le flux
      arrivent.forEach(function (t) { nettoyer(t); t.hidden = false; t.style.opacity = '0' })

      // 3. on lit la nouvelle mise en page, une seule fois
      var apres = new Map()
      restent.forEach(function (t) { apres.set(t, t.getBoundingClientRect()) })

      // 4. chaque restante repart de son ancienne position
      restent.forEach(function (t) {
        var a = avant.get(t)
        var b = apres.get(t)
        var dx = a.left - b.left
        var dy = a.top - b.top
        t.style.transition = 'none'
        t.style.transform = (dx || dy) ? 'translate(' + dx + 'px, ' + dy + 'px)' : ''
      })

      /* ⚠️ ON FORCE UN RECALCUL DE MISE EN PAGE, ON N ATTEND PAS
         `requestAnimationFrame`. Dans un onglet en arriere-plan rAF ne se
         declenche PAS DU TOUT : l animation ne partait jamais, et les vignettes
         sautaient a leur place au moment du nettoyage. Constate a la mesure —
         120 ms apres le clic, la transition n etait toujours pas posee.

         Lire `offsetHeight` fige l etat de depart tout de suite ; le changement
         qui suit part donc d une valeur deja calculee, et il est bien anime. */
      void cadre.offsetHeight

      restent.forEach(function (t) {
        t.style.transition = 'transform ' + DUREE + 'ms cubic-bezier(.22,.61,.36,1)'
        t.style.transform = ''
      })
      arrivent.forEach(function (t) {
        t.style.transition = 'opacity ' + DUREE + 'ms ease'
        t.style.opacity = '1'
      })
      partent.forEach(function (t) {
        t.style.transition = 'opacity ' + DUREE + 'ms ease, transform ' + DUREE + 'ms ease'
        t.style.opacity = '0'
        t.style.transform = 'scale(.86)'
      })

      /* ⚠️ ON NE NETTOIE QU AU BOUT DE LA DUREE, ET SEULEMENT SI PERSONNE N A
         RELANCE UN FILTRE ENTRE-TEMPS. Sans le jeton `generation`, deux choix
         rapproches laissaient la premiere animation cacher des tuiles que la
         seconde venait de faire revenir. */
      setTimeout(function () {
        if (mien !== generation) return
        partent.forEach(function (t) { nettoyer(t); t.hidden = true })
        restent.concat(arrivent).forEach(function (t) {
          t.style.transition = ''
          t.style.transform = ''
          t.style.opacity = ''
        })
      }, DUREE + 30)

      if (vide) vide.hidden = vus !== 0
    }

    function fermerTout(sauf) {
      menus.forEach(function (m) {
        if (m === sauf) return
        m.querySelector('.pr-cinema__choix').hidden = true
        m.querySelector('.pr-cinema__champ').setAttribute('aria-expanded', 'false')
      })
    }

    menus.forEach(function (menu) {
      var champ = menu.querySelector('.pr-cinema__champ')
      var liste = menu.querySelector('.pr-cinema__choix')
      var lignes = [].slice.call(liste.querySelectorAll('li'))
      var quoi = liste.dataset.prFiltre

      function basculer(ouvrir) {
        if (ouvrir) fermerTout(menu)
        liste.hidden = !ouvrir
        champ.setAttribute('aria-expanded', ouvrir ? 'true' : 'false')
      }

      champ.addEventListener('click', function () { basculer(liste.hidden) })

      /* ⚠️ LE CHAMP PREND LA LARGEUR DE SA LISTE, ET IL FAUT LA MESURER ICI.
         La liste est en position absolue : elle ne compte pas dans la largeur de
         son parent, si bien qu aucune regle CSS ne peut lui accorder cette
         largeur. Et on ne peut pas la remettre dans le flux — `hidden` vaut
         `display: none`, elle ne mesurerait plus rien tant qu elle est fermee.

         On l ouvre donc un instant en `visibility: hidden` — elle occupe sa place
         sans rien peindre ni recevoir de clic —, on lit sa largeur, on referme.
         Une seule lecture au chargement, avant que la page ne soit peinte.

         La grille des filtres etant en colonnes `1fr`, poser ce minimum sur les
         deux menus les aligne tous deux sur la PLUS LARGE des deux listes, sans
         calcul supplementaire. Demande de Loic. */
      liste.hidden = false
      liste.style.visibility = 'hidden'
      var large = Math.ceil(liste.getBoundingClientRect().width)
      liste.style.visibility = ''
      liste.hidden = true
      if (large) menu.style.minWidth = large + 'px'

      /* ⚠️ CHOISIR NE REFERME PAS LE MENU. Demande de Loic : la liste reste
         ouverte pour enchainer les essais, et ne se ferme qu au clic sur son
         champ ou ailleurs dans la page. On ne rend donc pas non plus le focus au
         champ — il resterait la ou il est, dans la liste. */
      function choisir(ligne) {
        valeurs[quoi] = ligne.dataset.valeur || ''
        lignes.forEach(function (a) {
          var actif = a === ligne
          a.classList.toggle('est-choisi', actif)
          a.setAttribute('aria-selected', actif ? 'true' : 'false')
        })
        appliquer(true)
      }

      lignes.forEach(function (ligne) {
        ligne.addEventListener('click', function () { choisir(ligne) })
        // Les lignes sont focalisables : Entree et Espace valent le clic.
        ligne.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); choisir(ligne) }
        })
      })

      menu.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape') return
        basculer(false)
        champ.focus()
      })
    })

    /* ⚠️ UN CLIC AILLEURS REFERME. Sans ca la liste restait ouverte sur la
       grille — le `<select>` natif s en chargeait tout seul, plus maintenant. */
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pr-menu]')) return
      fermerTout(null)
    })

    appliquer(false)
  }

  /* --------------------------------------------------------------------------
     🔴 DEUX FONCTIONS RETIREES LE 2026-08-27, avec le reste de la fiche du
     PrestaShop — Loic : « on reprend exactement le design de la fiche produit de
     BC+ ». BC+ n a ni l une ni l autre.

       - `armerColonneFiche` : collait la colonne d information PAR LE BAS pendant
         que la pile de visuels defilait (demande du 20/08). Le gabarit revient a
         `enable_sticky_columns: false` + `enable_sticky_atc: true`, donc il n y a
         plus de course a faire — et la barre d achat collante de BC+ prend le
         relais. Sa CSS (`.pr-colle`, `.pr-colle--fin`) est partie avec.

       - `armerAttributs` : pilotait le selecteur de Symmetry depuis la table
         couleur x tailles. Le bloc `.pr-attributs` n existe plus dans le gabarit,
         le selecteur du theme est de nouveau visible et se pilote tout seul.
         ⚠️ Emportait aussi le rappel de la galerie a l ecran au changement de
         declinaison SUR TELEPHONE. BC+ ne l a pas non plus ; si le geste manque
         sur mobile, c est ici qu il revient — mais alors pour les deux boutiques.

     Les deux se retrouvent entieres dans git, commit precedent.
     -------------------------------------------------------------------------- */

  /* --------------------------------------------------------------------------
     Le bouton FILTRER, remonte au-dessus de la description.

     Demande de Loic le 2026-08-21 : « le bouton filter doit etre entre la
     description et la banner au dessus ».

     ⚠️ POURQUOI DU JS POUR UN DEPLACEMENT. Le bouton est rendu dans
     `.utility-bar`, qui appartient au conteneur de la grille ; la description
     est le dernier bloc de `collection.description`, donc du conteneur d avant.
     Deux conteneurs differents : ni `order` (qui ne classe qu entre freres) ni
     un positionnement absolu (qui demanderait la hauteur, variable, de la
     description) ne franchissent cette frontiere.

     ⚠️ ON DEPLACE, ON NE RECONSTRUIT PAS. L element est le bouton du theme, avec
     son `data-toggle-filters` : l ecouteur de Symmetry le suit. Reconstruire un
     bouton obligerait a recabler l ouverture du panneau, le comptage des filtres
     actifs et l etat ARIA — pour rien.

     ⚠️ ET ON RECOMMENCE APRES CHAQUE FILTRAGE. Le filtrage AJAX de Symmetry
     REMPLACE la barre : le bouton deplace disparait avec elle, et le nouveau
     revient a sa place d origine. Le MutationObserver de `surveillerGrille` voit
     ce remplacement et rappelle la fonction.

     🔴 ET C EST LA QUE LES BOUTONS S EMPILAIENT. Signale par Loic le 2026-08-24 :
     un bouton de plus a CHAQUE filtre applique. Mesure sur « Planches Bodyboard » :
     1 bouton au chargement, puis 3, 4, 5 — « Filtrer », « Filtrer (1) »,
     « Filtrer », « Filtrer (2) », « Filtrer (3) ». L historique complet des etats
     restait a l ecran.
     La cause tient au SELECTEUR : il cherche un bouton DANS `.utility-bar`. Or
     celui qu on vient de deplacer n y est plus — il est dans notre ligne. La
     fonction retrouvait donc toujours le bouton NEUF de la barre reconstruite,
     l ajoutait, et ne retirait jamais l ancien.
     -> On VIDE la ligne avant d y poser le neuf. C est bien le neuf qu on veut :
        c est lui qui porte le compte de filtres actifs a jour.
     ⚠️ Et le selecteur ecarte desormais explicitement `--sticky-mobile-copy` :
        Symmetry rend DEUX barres, et la copie collante est le seul filtre
        atteignable une fois la grille defilee sur telephone. La prendre par
        megarde retirerait le bouton du mobile.
     -------------------------------------------------------------------------- */
  function placerBoutonFiltre() {
    if (!document.body.classList.contains('template-suffix-banniere')) return
    var description = document.querySelector('.page-header .rte .pr-band:not(.pr-s-cat-titre)')
    if (!description) return
    var bouton = document.querySelector(
      '.utility-bar:not(.utility-bar--sticky-mobile-copy) .toggle-btn[data-toggle-filters]',
    )
    if (!bouton) return
    var ligne = document.querySelector('.pr-filtre-ligne')
    if (!ligne) {
      ligne = document.createElement('div')
      ligne.className = 'pr-filtre-ligne'
      description.parentNode.insertBefore(ligne, description)
    }
    if (bouton.parentNode === ligne) return
    while (ligne.firstChild) ligne.removeChild(ligne.firstChild)
    ligne.appendChild(bouton)
  }

  function demarrer() {
    armerBandes()
    placerBoutonFiltre()
    surveillerGrille()
    armerTuiles()
    armerCinema()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer)
  } else {
    demarrer()
  }
})()
